import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// Both of these apply a persisted UI preference to <html> at module load, before
// React renders — no flash of the wrong theme or the wrong language.
import './lib/theme';
import './i18n';
import App from './App.tsx';
import { LabOSAuth } from './lib/labos.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LabOSAuth appId="agentic-story-engine-wbdlab">
      <App />
    </LabOSAuth>
  </StrictMode>,
);
